import React from "react";

import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Table,
  Typography,
  colors,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles(theme => ({
  cardContent: {
    padding: 0,
  },
  item: {
    padding: theme.spacing(0),

    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(2),
    },
  },
  title: {
    padding: theme.spacing(1, 2, 2, 2),

    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(0),
      marginBottom: theme.spacing(2),
    },
  },
  tableRow: {
    borderBottom: `1px solid ${colors.blueGrey[50]}`,
  },
  tableCell: {
    padding: theme.spacing(3, 2, 3, 2),

    [theme.breakpoints.up("sm")]: {
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
    },
  },
}));

const MyBusinessCardSkeleton: React.FC = () => {
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Card>
      <CardHeader
        title={<Skeleton width={isMobile ? "100%" : "300px"} height="40px" />}
      />
      <Divider />
      <CardContent className={classes.cardContent}>
        <Grid container direction={isMobile ? "column" : "row"} wrap="wrap">
          <Grid item sm={6} xs={12} className={classes.item}>
            <Typography variant="h2" color="textSecondary">
              <Skeleton width={isMobile ? "100%" : "250px"} height="40px" />
            </Typography>
            <Table>
              <tbody>
                <tr className={classes.tableRow}>
                  <td className={classes.tableCell}>
                    <Skeleton
                      width={isMobile ? "100%" : "150px"}
                      height="40px"
                    />
                  </td>
                  <td className={classes.tableCell}>
                    <Skeleton
                      width={isMobile ? "100%" : "160px"}
                      height="40px"
                    />
                  </td>
                </tr>
                <tr className={classes.tableRow}>
                  <td className={classes.tableCell}>
                    <Skeleton
                      width={isMobile ? "100%" : "150px"}
                      height="40px"
                    />
                  </td>
                  <td className={classes.tableCell}>
                    <Skeleton
                      width={isMobile ? "100%" : "250px"}
                      height="40px"
                    />
                  </td>
                </tr>
                <tr className={classes.tableRow}>
                  <td className={classes.tableCell}>
                    <Skeleton
                      width={isMobile ? "100%" : "150px"}
                      height="40px"
                    />
                  </td>
                  <td className={classes.tableCell}>
                    <Skeleton
                      width={isMobile ? "100%" : "125px"}
                      height="40px"
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default MyBusinessCardSkeleton;
